import { apiPost } from '../../api'

export const save_update_configurations = data => {
  return apiPost({
    endpoint: 'recruitment/save_update_configurations',
    data
  })
}
